import React from 'react';
import { ICON } from 'resources/constants';
import {
  Container,
  NumberWrapper,
  Number,
  Icon,
  Loader,
  Answer,
} from './elements';

type Props = {
  readonly className?: string;
  readonly onClick?: () => void;
  readonly number: number;
  readonly isHighlighted?: boolean;
  readonly wasCorrect?: boolean;
  readonly currentAnswer?: boolean;
  readonly isLoading?: boolean;
  readonly hasAnswered?: boolean;
  readonly answerText: string;
};

function AnswerComponent({
  className,
  onClick,
  number,
  isHighlighted,
  wasCorrect,
  answerText,
  isLoading,
  hasAnswered,
  currentAnswer,
}: Props): React.ReactElement {
  const icon = wasCorrect ? ICON.check : ICON.close;
  const backgroundColor = wasCorrect ? '#8BC34A' : '#D9464D';

  return (
    <Container
      onClick={onClick}
      canClick={!(isLoading || hasAnswered)}
      isHighlighted={!currentAnswer && isHighlighted}
      className={className}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <NumberWrapper backgroundColor={currentAnswer && backgroundColor}>
          {currentAnswer ? (
            <Icon color={'#fff'} icon={icon} />
          ) : (
            <Number>{number}</Number>
          )}
        </NumberWrapper>
      )}

      <Answer>{answerText}</Answer>
    </Container>
  );
}

export default AnswerComponent;
